'use strict';
(function () {
  var _controller = 'storeDeliveryMethod.controller';
  angular.module('pentaApp').controller(_controller, controller);
  controller.$inject = ['$scope', 'flyer.resource'];
  function controller($scope, flyerResource) {
    /// METHODS
    $scope.mainResource = flyerResource;
    $scope.pay = pay;

    /// VARS
    // WATCHERS
    $scope.$on('$destroy', onDestroy);

    /// INIT
    init();


    /////////////////////

    function init() {
    }

    function pay(reservation){
      appNavigator.pushPage('mercadoPagoByApi/mercadoPagoByApi.jade', { 
        data: { 
          amount: 500,
          comment: '',
          type: 'STORE',
          onClose: function(){
            appNavigator.pushPage('store/storeTracking/storeTracking.jade', { data: { onClose: Function.Prototype } });
          } 
        } 
      });
    }


    function onDestroy() {
      $scope.$root.abortRequests(_controller);
    }

    //// FIN CONTROLLER
  }
})();
